import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import DownloadButtons from '../ui/DownloadButtons';
import { Logo } from '../../assets/icons';

interface BottomCTAProps {
  nomad?: 1 | 2 | 3 | 4;
  className?: string;
}

export const BottomCTA: React.FC<BottomCTAProps> = ({
  nomad = 1,
  className,
}) => {
  const { images } = useStaticQuery(graphql`
    query bottomCTA {
      images: allFile(filter: { relativeDirectory: { eq: "bottom-cta" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(placeholder: NONE)
            }
          }
        }
      }
    }
  `);

  const nomadImages = useMemo(
    () =>
      images.edges.reduce((acc: any, { node }: any) => {
        acc[node.name] = node.childImageSharp.gatsbyImageData;

        return acc;
      }, {}),
    [images],
  );

  return (
    <section className="mx-3 rounded-lg md:mx-0 bg-blue-50 md:bg-transparent">
      <div className="container px-3 py-10 md:flex md:items-center md:py-0">
        <Logo className="mx-auto mb-5 text-blue-500 max-w-48 md:hidden" />

        <div className="flex flex-col items-center flex-1 gap-6 text-center md:gap-8 md:items-start md:text-left">
          <h3 className="text-4xl font-bold text-blue-500">
            <span className="text-yellow-400">Start</span> Building Your Travel
            Network <span className="text-yellow-400">Today</span>
          </h3>

          <DownloadButtons className="max-w-sm" />
        </div>

        <div className="flex-1 hidden md:block">
          <GatsbyImage
            className="w-full"
            image={nomadImages[`nomad_${nomad}`]}
            alt="Happy Nomad"
          />
        </div>
      </div>
    </section>
  );
};
